import { Award, Star, GraduationCap, ShieldCheck, MapPin } from "lucide-react";
import { ReactNode } from "react";

interface TrustBarProps {
  children?: ReactNode;
}

export default function TrustBar({ children }: TrustBarProps) {
  return (
    <section className="relative z-40 bg-primary h-auto">
      <div className="relative w-full overflow-hidden">
        {/* Trust Bar */}
        {/* Mobile: manual horizontal scroll. Desktop: centered wrapping. */}
        <div className="h-10 flex items-center overflow-x-auto lg:overflow-hidden border-b bg-white shadow-sm relative z-20 scrollbar-hide">
          <div className="flex items-center justify-start lg:justify-center flex-nowrap lg:flex-wrap gap-8 lg:gap-x-6 lg:gap-y-4 xl:gap-x-12 px-6 lg:px-4 lg:pr-4 text-[10px] xl:text-xs font-bold text-primary uppercase tracking-widest whitespace-nowrap lg:whitespace-normal w-max lg:w-full shrink-0 lg:max-w-7xl lg:mx-auto">
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              <Award className="w-4 h-4 md:w-5 lg:w-5 xl:w-6 md:h-5 lg:h-5 xl:h-6 text-accent" />{" "}
              PROVEN RESULTS
            </div>
            <div className="hidden lg:block w-px h-6 bg-border"></div>
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              <Star className="w-4 h-4 md:w-5 lg:w-5 xl:w-6 md:h-5 lg:h-5 xl:h-6 text-accent" />{" "}
              5 STAR REVIEWS
            </div>
            <div className="hidden lg:block w-px h-6 bg-border"></div>
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              <GraduationCap className="w-4 h-4 md:w-5 lg:w-5 xl:w-6 md:h-5 lg:h-5 xl:h-6 text-accent" />{" "}
              QUALIFIED AND ETHICAL
            </div>
            <div className="hidden lg:block w-px h-6 bg-border"></div>
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              <ShieldCheck className="w-4 h-4 md:w-5 lg:w-5 xl:w-6 md:h-5 lg:h-5 xl:h-6 text-accent" />{" "}
              RELIABLE AND HONEST
            </div>
            <div className="hidden lg:block w-px h-6 bg-border"></div>
            <div className="flex items-center gap-2 md:gap-3 shrink-0">
              <MapPin className="w-4 h-4 md:w-5 lg:w-5 xl:w-6 md:h-5 lg:h-5 xl:h-6 text-accent" />{" "}
              LOCAL
            </div>
          </div>
        </div>

        {/* Hero Section or other content */}
        {children}
      </div>
    </section>
  );
}
